import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Icon } from '../../Icon';
import { Tooltip } from '../../Tooltip';
import { useTranslation } from '../../i18n';
export const CollapseTrigger = ({ isCollapsed, style, toggleIsCollapsed }) => {
    const { t } = useTranslation();
    return (_jsx(Tooltip, Object.assign({ placement: "right", title: isCollapsed ? t('展开') : t('收起'), align: isCollapsed ? undefined : { offset: [8] } }, { children: _jsx(StyledCollapsed, Object.assign({ onClick: toggleIsCollapsed, isCollapsed: isCollapsed, onMouseEnter: e => e.stopPropagation(), style: style }, { children: _jsx(Icon, { icon: isCollapsed ? 'Open' : 'PutAway', size: 16, style: {
                    cursor: 'pointer',
                } }, void 0) }), void 0) }), void 0));
};
const StyledCollapsed = styled.div `
  ${props => !props.isCollapsed
    ? css `
          position: absolute;
          top: 50%;
          right: 12px;
          z-index: 1;
          transform: translateY(-50%);
          height: 24px;
          width: 24px;
        `
    : ``}

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  &&& .anticon {
    cursor: pointer;
    margin: 0;
    color: ${props => props.theme.text._3};
    :hover {
      color: ${props => props.theme.brand.text0};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sbGFwc2VUcmlnZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL0FwcExheW91dC9jb21wb25lbnRzL0NvbGxhcHNlVHJpZ2dlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUlBLE9BQU8sTUFBTSxFQUFFLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUE7QUFFL0MsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFlBQVksQ0FBQTtBQUNqQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sZUFBZSxDQUFBO0FBQ3ZDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxZQUFZLENBQUE7QUFFM0MsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQWF2QixDQUFDLEVBQUUsV0FBVyxFQUFFLEtBQUssRUFBRSxpQkFBaUIsRUFBRSxFQUFFLEVBQUU7SUFDakQsTUFBTSxFQUFFLENBQUMsRUFBRSxHQUFHLGNBQWMsRUFBRSxDQUFBO0lBRTlCLE9BQU8sQ0FDTCxLQUFDLE9BQU8sa0JBQ04sU0FBUyxFQUFDLE9BQU8sRUFDakIsS0FBSyxFQUFFLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQ3RDLEtBQUssRUFBRSxXQUFXLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRSxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxnQkFFaEQsS0FBQyxlQUFlLGtCQUNkLE9BQU8sRUFBRSxpQkFBaUIsRUFDMUIsV0FBVyxFQUFFLFdBQVcsRUFDeEIsWUFBWSxFQUFFLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLGVBQWUsRUFBRSxFQUN0QyxLQUFLLEVBQUUsS0FBSyxnQkFFWixLQUFDLElBQUksSUFDSCxJQUFJLEVBQUUsV0FBVyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFNBQVMsRUFDdEMsSUFBSSxFQUFFLEVBQUUsRUFDUixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFNBQVM7aUJBQ2xCLFdBQ0QsWUFDYyxZQUNWLENBQ1gsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBRWhDO0lBQ0UsS0FBSyxDQUFDLEVBQUUsQ0FDUixDQUFDLEtBQUssQ0FBQyxXQUFXO0lBQ2hCLENBQUMsQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7O1NBUUY7SUFDSCxDQUFDLENBQUMsRUFBRTs7Ozs7Ozs7Ozs7YUFXRyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEVBQUU7O2VBRTFCLEtBQUssQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsS0FBSzs7O0NBRzlDLENBQUEifQ==